import { TagsEditor } from "@/components/TagsEditor";

/* ONE canonical Tags control for Customer 360 (2026-09 correction).
   Previously showed two separate controls — Customer tags (contacts.tags)
   and Opportunity tags (opportunities.tags) — which read as two competing
   tag systems to an employee. The tags actually used in SalesOS
   (Responsive/Unresponsive/Docs Pending/Docs Complete/Eligible/
   Borderline/Not Eligible/High Risk/...) are about ONE product pursuit,
   and a customer can legitimately be Eligible for one product and
   Borderline for another — a single global customer-level tag set would
   silently contradict itself across a customer's several opportunities.
   So this now shows ONLY the currently-selected opportunity's own tags
   (opportunities.tags, via the same unmodified TagsEditor/entity=
   "opportunity" — no new tagging architecture). Switching the selected
   opportunity in Customer 360 re-renders this with that opportunity's own
   tags automatically, since `opportunityTags` is derived from the
   currently-selected `opp` object one level up.

   contacts.tags itself is untouched (never deleted, still a valid
   POST /tags/assign|remove target with entity="contact") — any
   pre-existing customer-level tag data was copied forward onto that
   contact's active opportunities by a one-time startup migration
   (services.migrate_legacy_contact_tags_to_opportunities), so nothing
   that already existed silently disappears from view. */
export const TagsPanel = ({ opportunityId, opportunityTags, opportunityLabel }) => (
  <div className="flex items-center gap-2" data-testid="tags-panel">
    <span className="text-[9px] font-medium text-muted-foreground uppercase tracking-wide w-20 shrink-0"
      title={opportunityLabel ? `Tags — ${opportunityLabel}` : "Tags"}>
      Tags
    </span>
    {opportunityId ? (
      <TagsEditor entity="opportunity" recordId={opportunityId} tags={opportunityTags} />
    ) : (
      <span className="text-xs text-muted-foreground">Select a product pursuit to tag it.</span>
    )}
  </div>
);
